import(/* webpackMode: "eager", webpackExports: ["KlingMotionPageClient"] */ "/app/apps/frontend/app/(dashboard)/apps/kling-motion/client.tsx");
